import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';

export const ORDERING_PLATFORM_OPTIONS = [
  'CondoCerts',
  'HomeWiseDocs',
  'CommunityArchive',
  'CiraConnect',
];

const OrderingPlatformField = ({ value = '', onChange, className = 'mb-2', hideLabel = false }) => {
  const isKnown = ORDERING_PLATFORM_OPTIONS.includes(value);
  // Default empty → "Select platform if applicable" (not Other)
  const selectValue = isKnown ? value : value ? 'Others' : '';
  const showCustomInput = Boolean(value) && !isKnown;

  return (
    <Form.Group className={className}>
      {!hideLabel && <Form.Label className="small mb-0">Ordering platform</Form.Label>}
      <Row>
        <Col md={showCustomInput ? 4 : 12} className={showCustomInput ? 'pr-md-1' : ''}>
          <Form.Control
            as="select"
            size="sm"
            value={selectValue}
            onChange={e => {
              if (e.target.value === 'Others') {
                onChange('Others');
              } else {
                onChange(e.target.value);
              }
            }}
          >
            <option value="">Select platform if applicable</option>
            {ORDERING_PLATFORM_OPTIONS.map(platform => (
              <option key={platform} value={platform}>
                {platform}
              </option>
            ))}
            <option value="Others">Other</option>
          </Form.Control>
        </Col>
        {showCustomInput && (
          <Col md={8} className="pl-md-1 mt-2 mt-md-0">
            <Form.Control
              type="text"
              size="sm"
              value={value === 'Others' ? '' : value}
              onChange={e => onChange(e.target.value || 'Others')}
              placeholder="Enter platform name"
            />
          </Col>
        )}
      </Row>
    </Form.Group>
  );
};

export default OrderingPlatformField;
